const items = {
  "channel.title": "版本风格",
  "channel.type": "类型",
  "channel.name": "名称",
  "channel.create.message.noname": "请输入版本名称",
  "channel.type.all.title": "全部",
  "channel.type.translation.label": "译文",
  "channel.type.nissaya.label": "Nissaya",
  "channel.type.commentary.label": "注疏",
  "channel.type.original.label": "原文",
  "channel.type.message.required": "请输入版本类型",
  "channel.lang": "语言",
  "channel.fields.lang.label": "语言",
  "channel.fields.type.label": "类型",
  "channel.fields.name.label": "名称",
  "channel.type.similar.label": "相似句",
};

export default items;
